<template>
    <fieldset style="margin-bottom: 20px;" class="answerTableCell">
        <RejectDialog ref="rejectDialog" :answer-id="answer.id" :uri="uri" :is-doctor="Boolean(answer.doctor)" v-on="$listeners" />
        <ApproveWithoutPaymentDialog ref="approveWithoutPaymentDialog" :answer="answer" :uri="uri" :deleted-files="deletedFiles" v-on="$listeners" />

        <legend>
            <!-- todo: there are some answers without question... check db -->
            <a v-if="answer.question"
               :href="answer.question.fullUrl"
               target="_blank"
               class="comma"
            >
                <span v-if="answer.doctor">
                    <text-highlight :queries="searchDoctorOrUserName">
                      {{ answer.doctor.nameFamily }} {{ answer.doctor.nameFirst }} {{ answer.doctor.nameFathers }}
                    </text-highlight>
                </span>
                <span v-else-if="answer.user">
                    <text-highlight :queries="searchDoctorOrUserName">
                      {{ answer.user.username ? answer.user.username : 'Пациент' }}
                    </text-highlight>
                </span>
                <span v-else-if="answer.doctor_url.indexOf('duty_doctor') !== -1">
                    Дежурный врач
                </span>
            </a>
            <span v-else>~nq~</span><!-- todo: there are some answers without question... check db -->
        </legend>

        <table class="grid">
            <tr>
                <td>
                    <span v-if="answer.doctor" class="comma">
                        {{ answer.doctor.specialitiesAsText }}
                    </span>
                    <span v-else-if="answer.user">
                        {{ answer.user.phoneFormatted }}
                    </span>
                    <span v-else-if="answer.doctor_url === 'duty_doctor'">
                        Терапевт
                    </span>
                    <span v-else-if="answer.doctor_url.indexOf('duty_doctor') !== -1">
                        {{ answer.doctorUser.username }}
                    </span>
                </td>
                <td align="center" style="font-size: 16px;">
                    <b v-if="answer.question.type === 'INDIVIDUAL'">Индивидуальный</b>
                </td>
                <td style="text-align: right">
                    <b>{{ answer.created_at | formatDateTime }},</b>
                    <b v-if="answer.question.type === 'FREE'" style="font-size: 16px">бесплатно</b>
                    <b v-else style="font-size: 16px">{{ answer.question.price }} руб.</b>
                </td>
            </tr>
            <tr>
                <td width="33%"></td>
                <td width="33%"></td>
                <td width="33%"></td>
            </tr>
            <tr>
                <td colspan="3">
                    <div class="textareaMarkable">
                        <textarea v-model="answer.text"
                                  class="answer-text"
                                  v-beautify.literal="'capitalize itemclean striptags trim typograf'"/>
                    </div>
                </td>
            </tr>
            <tr v-if="answer.attachments.length">
              <td colspan="3">
                  <template v-for="attachment in answer.attachments">
                      <span style="display: flex; align-items: center;">
                          <a v-if="attachment.deleted_at" :class="{del: deletedFiles.indexOf(attachment.id) !== -1}"
                             href="#"
                             @click.prevent
                             style="display: block; width: fit-content;">
                              &nbsp;Файл удален
                          </a>
                          <a v-else :class="{del: deletedFiles.indexOf(attachment.id) !== -1}"
                             :href="prepareFileUrl(attachment.url)"
                             target="_blank"
                             style="display: block; width: fit-content;">
                               {{ attachment.title}}
                          </a>
                          <i class="fa fa-times"
                             @click="toggleDeleteFile(attachment.id)"
                             style="margin-left: 10px; color: #3c8dbc;"/>
                      </span>
                  </template>
              </td>
            </tr>
            <tr>
                <td colspan="2">
                    <strong v-if="answer.moderated_at && !answer.published">причина: {{ answer.reject_reason }}</strong>
                    <strong v-if="answer.moderated_at && answer.published && answer.is_without_payment">
                        Без оплаты: {{ answer.without_payment_reason }}
                    </strong>
                </td>
                <td>
                    <div v-if="!answer.question.deleted_at" class="controls" style="float: right; white-space: nowrap;">
                        <template v-if="
                                (answer.question.type !== 'FREE'  && $can('admin.consult.answers.questionsPayable.update')) ||
                                (answer.question.type === 'FREE' && $can('admin.consult.answers.questionsFree.update'))">
                            <template v-if="!answer.moderated_at">
                                <button class="greenHover" @click="approve">Опубликовать</button>
                                <button v-if="answer.doctor && answer.question.type !== 'FREE' && answer.question.type !== 'INDIVIDUAL'" class="greenHover" @click="approveWithoutPayment">
                                    Опубликовать без оплаты
                                </button>
                                <button class="redHover" @click="reject">Отклонить</button>
                            </template>
                            <template v-if="answer.moderated_at && answer.published">
                                <button class="blueHover" @click="update">Сохранить</button>
                                <template v-if="answer.doctor && answer.question.type !== 'FREE'  && answer.question.type !== 'INDIVIDUAL'">
                                    <button v-if="answer.is_without_payment" class="greenHover" @click="approve">Опубликовать</button>
                                    <button v-if="!answer.is_without_payment" class="greenHover" @click="approveWithoutPayment">Опубликовать без оплаты</button>
                                </template>
                                <button class="redHover" @click="reject">Отклонить</button>
                            </template>
                            <template v-if="answer.moderated_at && !answer.published">
                                <button class="blueHover" @click="update">Сохранить</button>
                                <button class="greenHover" @click="approve">Опубликовать</button>
                                <button v-if="answer.doctor && answer.question.type !== 'FREE' && answer.question.type !== 'INDIVIDUAL'" class="greenHover" @click="approveWithoutPayment">
                                    Опубликовать без оплаты
                                </button>
                            </template>
                        </template>
                        <template v-if="
                                (answer.question.type !== 'FREE'  && $can('admin.consult.answers.questionsPayable.delete')) ||
                                (answer.question.type === 'FREE' && $can('admin.consult.answers.questionsFree.delete'))">
                            <button class="redHover" @click="destroy">Удалить</button>
                        </template>
                    </div>
                    <div v-else style="float: right">
                        <b>Вопрос удален</b>
                    </div>
                </td>
            </tr>
        </table>
    </fieldset>
</template>

<script>
    import RejectDialog from "./RejectDialog";
    import ApproveWithoutPaymentDialog from "./ApproveWithoutPaymentDialog";
    import TextHighlight from "vue-text-highlight";

    export default {
        components: {RejectDialog, ApproveWithoutPaymentDialog, TextHighlight},
        props: {
            answer: { type: Object, required: true }
        },
        data: () => ({
            uri: '/admin/consult/answers/',
            deletedFiles: [],
        }),
        methods: {
            approve() {
                this.axios
                    .post(this.uri + 'approve/' + this.answer.id, {
                        text: this.answer.text,
                        deletedFiles: this.deletedFiles,
                    })
                    .then(response => {
                        this.$emit('updatePlease')
                        this.$bus.fire('updateMenu');
                    })
                    .catch(response => {
                        this.showModalQuestionIsDeleted(response.errors.common[0]);
                    })
            },
            approveWithoutPayment() {
                this.$refs.approveWithoutPaymentDialog.$refs.dialog.show()
            },
            reject() {
                this.$refs.rejectDialog.$refs.dialog.show()
            },
            update() {
                this.axios
                    .put(this.uri + this.answer.id, {
                        text: this.answer.text,
                        deletedFiles: this.deletedFiles,
                    })
                    .then(response => {
                        this.$emit('updatePlease')
                        this.$bus.fire('updateMenu');
                    })
                    .catch(response => {
                        this.showModalQuestionIsDeleted(response.errors.common[0]);
                    })
            },
            destroy() {
                let sure = confirm("Удалить?")

                if (sure) {
                    this.axios
                        .delete(this.uri + this.answer.id)
                        .then(response => {
                            this.$emit('updatePlease')
                            this.$bus.fire('updateMenu');
                        })
                        .catch(response => {
                            this.showModalQuestionIsDeleted(response.errors.common[0]);
                        })
                }
            },
            toggleDeleteFile(fileName) {
                let i = this.deletedFiles.indexOf(fileName);

                if (i === -1) {
                    this.deletedFiles.push(fileName);
                } else {
                    this.deletedFiles.splice(i, 1);
                }
            },
            prepareFileUrl(fileUrl) {
                return fileUrl.indexOf('http') === -1 ? '//' + fileUrl : fileUrl;
            },
            showModalQuestionIsDeleted(errorText) {
                this.$modal(errorText,{
                    name: 'ОК',
                    callback: () => {},
                },{}, false, 'only-text-dialog');
            }
        },
        computed: {
            searchDoctorOrUserName() {
                if (this.$parent.$parent.$parent.filter.doctorOrUserName) {
                   return this.$parent.$parent.$parent.filter.doctorOrUserName.split(' ');
                }

                return '';
            },
        },
    }
</script>

<style>
.answerTableCell mark.text__highlight {
  background: #ff0;
}
</style>
